import { api } from "app/data/api";


export const refreshAuth = async (refreshToken: string) => {
    return await api.post("/token/refresh", {
        refresh_token: refreshToken,
    });
};

export const loginAuth = async (email: string, password: string, cookieToken: string) => {
    return await api.post("auth/login", {
        email,
        password: password,
        cookieToken
    });
};

export const registerAuth = async (name:string, email: string, cpf: string, password: string) => {
    return await api.post("/auth/register", {
        email,
        name,
        cpf,
        password,
    });
};

export const forgotPasswordAuth = async (email: string) => {
    return await api.post('/auth/forgotPassword', {
        email
    })
}

export const resetPasswordAuth = async (token: string, password: string, retypePassword: string) => {
    return await api.post('/auth/resetPassword', {
        token,
        password,
        retypePassword
    })
}

export const activateAccounteAuth = async (token: string) => {
    return await api.post('/auth/activateAccount', {
        token
    })
}   
  
  
  